export default __webpack_public_path__ + "static/qren-logo-51a6bfc3fa1c94370bdb3eab2c4f3e71.png";